import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import type { Transaction, TransactionResponse } from '../models/transaction.model';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class TransactionService {
  private readonly api = inject(ApiService);

  constructor(private http: HttpClient) { }

  /**
   * Create a new transaction
   * @param transaction - The transaction data to create
   * @returns Observable of the created transaction response
   */
  createTransaction(transaction: Transaction): Observable<TransactionResponse> {
    return this.api.post<TransactionResponse>('admin/transactions', transaction);
  }

  updateTransaction(id: string, transaction: Partial<Transaction>): Observable<TransactionResponse> {
    return this.api.patch<TransactionResponse>(`admin/transactions/${id}`, transaction);
  }

  deleteTransaction(id: string): Observable<any> {
    return this.api.delete<any>(`admin/transactions/${id}`);
  }

  /**
   * Get Transactiom List
   * @param customerType 
   * @returns 
   */
  getTransactionList(
    customerType?: string,
    page = 1,
    limit = 10,
    filters: {
      search?: string;
      status?: string;
      transaction_type?: string;
      currency?: string;
      date_from?: string;
      date_to?: string;
      client?: string;
    } = {}
  ): Observable<any> {
    let params = new HttpParams();
    params = params.set('page', page).set('limit', limit);

    if (customerType) {
      params = params.set('customer_type', customerType.toLowerCase());
    }

    if (filters.search) params = params.set('search', filters.search);
    if (filters.status && filters.status !== 'all') params = params.set('status', filters.status);
    if (filters.transaction_type && filters.transaction_type !== 'all') params = params.set('transaction_type', filters.transaction_type);
    if (filters.currency && filters.currency !== 'all') params = params.set('currency', filters.currency);
    if (filters.date_from) params = params.set('date_from', filters.date_from);
    if (filters.date_to) params = params.set('date_to', filters.date_to);
    if (filters.client && filters.client !== 'all') params = params.set('client', filters.client);

    return this.http.get(`${environment.API_BASE_URL}admin/transactions`, { params });
  }
  
  /**
   * Retrieves details for a single transaction.
   */
  getTransaction(id: string): Observable<any> {
    return this.http.get(`${environment.API_BASE_URL}admin/transactions/${id}`);
  }
  getDashboardStats(): Observable<any> {
    return this.http.get(`${environment.API_BASE_URL}admin/users/dashboard-stats`);
  }

  /**
   * List transactions (if needed later)
   * @param params - Query params like page, limit, etc.
   */
  // getTransactions(params?: any): Observable<any> {
  //   return this.api.get('admin/transactions', params);
  // }
}
